export default "__VITE_ASSET__rtZe0ioT__"